import styled from 'styled-components'
import { FONT_SIZE, NATIVE_BASE_COLORS } from '../../../themes'

export const StyleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;

  .header-issue-modal {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.LG2};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    text-align: center;
  }
`

export const StyleContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 40px;

  .detail-issue-modal {
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    text-align: center;
  }
`

export const StyleFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;

  .done-button {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ colorTheme }) => colorTheme.MAIN || NATIVE_BASE_COLORS.PRIMARY[200]};
    outline: none;
    border: 1px solid ${({ colorTheme }) => colorTheme.MAIN || NATIVE_BASE_COLORS.PRIMARY[200]};
    border-radius: 4px;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.TN};
    color: ${({ colorTheme }) => colorTheme.FONT_COLOR.TEXT || NATIVE_BASE_COLORS.TEXT[800]};
    cursor: pointer;
  }
`
